<template>
    <div class="ui red basic label"
        :class="[
            (pointing) ? pointing + ' pointing' : '',
            (is_required) ? '': ' orange'
        ]">
        {{
            (is_required) ? '必填': '有則填寫'
        }}
    </div>
</template>

<script>
export default {
    props: {
        pointing: {
            default: 'left',
            type: String
        },
        is_required: {
            default: true,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>

</style>
